import { render, staticRenderFns } from "./ThankYouView.vue?vue&type=template&id=04d804ae&"
import script from "./ThankYouView.vue?vue&type=script&lang=js&"
export * from "./ThankYouView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports